
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'Nouveautes',
  computed: {
    ...mapGetters({ nouveautes: 'nouveautes/list', alerte: 'nouveautes/alerte' })
  },
  created () {
    setTimeout(this.clearAlerte, 1000);
  },
  methods: {
    ...mapActions({ clearAlerte: 'nouveautes/clearAlerte' })
  }
});
